import { WithholdingTax } from './withholding-tax.interface';
import { WithholdingTaxesService } from './withholding-tax.service';

const service = new WithholdingTaxesService();

export interface WithholdingTaxState {
   withholdingTaxes: Array<WithholdingTax>;
}
const state: WithholdingTaxState = {
   withholdingTaxes: [],
};

const getters = {
   withholdingTaxes(state: WithholdingTaxState) {
      return state.withholdingTaxes;
   },
};

const mutations = {
   SET_WITHHOLDING_TAXES(state: WithholdingTaxState, withholdingTaxes: Array<WithholdingTax>) {
      state.withholdingTaxes = withholdingTaxes;
   },
};

const actions = {
   async getWithholdingTaxes(context: any) {
      return await service.getWithholdingTaxes().then((response) => {
         context.commit('SET_WITHHOLDING_TAXES', response);
         return response;
      });
   },
};

export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations,
};
